import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/index';
import {map} from 'rxjs/internal/operators';
import * as moment from 'jalali-moment';
// import * as XLSX from 'xlsx';

type EntityResponseType = HttpResponse<IStaffReportModel>;
type EntityArrayResponseType = HttpResponse<IStaffReportModel[]>;
// import * as FileSaver from 'file-saver';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {IStaffReportModel} from '../../shared/model/staffReport.model';
import {CallReportModel, ICallReportModel} from "../../shared/model/callReport.model";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({ providedIn: 'root' })
export class CallService {
    public resourceUrl = SERVER_API_URL + 'api/call';

    constructor(protected http: HttpClient) {}

    create(callReportModel: ICallReportModel): Observable<EntityResponseType> {
      // alert(' in create action date ==' + staffReportModel.actionDate)
        const copy = this.convertDateFromClient(callReportModel);
      // alert(' in creat ecopy action date ==' + copy.actionDate)

      return this.http
            .post<ICallReportModel>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    update(callReportModel: ICallReportModel): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(callReportModel);
        return this.http
            .put<ICallReportModel>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<ICallReportModel>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICallReportModel[]>(this.resourceUrl + '/report', {params: options, observe: 'response'});
  }

    queryForFive(req?: any): Observable<EntityArrayResponseType> {
      const options = createRequestOption(req);
      return this.http.get<ICallReportModel[]>(this.resourceUrl + '/5-report', {params: options, observe: 'response'});
  }


    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    protected convertDateFromClient(callReportModel: ICallReportModel): IStaffReportModel {
        const copy: IStaffReportModel = Object.assign({}, callReportModel, {
            // expiratioDate:
            //     staffReportModel.expiratioDate != null && staffReportModel.expiratioDate.isValid()
            //         ? staffReportModel.expiratioDate.format(DATE_FORMAT)
            //         : null,
            // actionDate:
            //     staffReportModel.actionDate != null && staffReportModel.actionDate.isValid() ? staffReportModel.actionDate.format(DATE_FORMAT) : null,
            // followupbyDate:
            //     staffReportModel.followupbyDate != null && staffReportModel.followupbyDate.isValid()
            //         ? staffReportModel.followupbyDate.format(DATE_FORMAT)
            //         : null,
          // createdDate:
          //       staffReportModel.createdDate != null && staffReportModel.createdDate.isValid() ? staffReportModel.createdDate.format(DATE_TIME_FORMAT) : null
        });
        return copy;
    }

    protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
        if (res.body) {
            // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
            // res.body.actionDate = res.body.actionDate != null ? moment(res.body.actionDate) : null;
            // res.body.followupbyDate = res.body.followupbyDate != null ? moment(res.body.followupbyDate) : null;
            // res.body.createdDate = res.body.createdDate != null ? moment(res.body.createdDate) : null;
        }
        return res;
    }

    protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        if (res.body) {
            res.body.forEach((callReportModel: ICallReportModel) => {
                // staffReportModel.expiratioDate = staffReportModel.expiratioDate != null ? moment(staffReportModel.expiratioDate) : null;
                // staffReportModel.actionDate = staffReportModel.actionDate != null ? moment(staffReportModel.actionDate) : null;
                // staffReportModel.followupbyDate = staffReportModel.followupbyDate != null ? moment(staffReportModel.followupbyDate) : null;
                // staffReportModel.createDate = staffReportModel.createDate != null ? moment(staffReportModel.createDate) : null;
            });
        }
        return res;
    }

    searchReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ICallReportModel[]>(this.resourceUrl + '-search-report', {params: options, observe: 'response'});
  }



  // search(req?: any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<ICallReportModel[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  // }
  //
  // searchReport(req?: any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<IStaffReportModel[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  // }


  // public exportAsExcelFile(json: any[], excelFileName: string): void {
  //   // alert(' json == ' + json.length);
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
  //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  // }

  // public exportAsExcelFile2(json: StaffReportModel[], excelFileName: string): void {
  //   // alert(' json == ' + json.length);
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
  //   const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
  //   const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  // }

  // private saveAsExcelFile(buffer: any, fileName: string): void {
  //   const data: Blob = new Blob([buffer], {
  //     type: EXCEL_TYPE
  //   });
    // FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
 // }

}
